"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DatasetEntity_1 = __importDefault(require("../entities/DatasetEntity"));
class DatasetEntityArrayManagement {
    constructor(datasets, colorGenerator) {
        this._datasets = [];
        colorGenerator.generateHexLinesColor(datasets.length);
        datasets.forEach((dataset, index) => {
            const color = dataset.color != null ? dataset.color : colorGenerator.getLineColor(index);
            colorGenerator.addToPickedColors(color);
            this._datasets.push(new DatasetEntity_1.default(dataset, color));
        });
    }
    get datasets() {
        return this._datasets;
    }
    getTimeRange(dateRange) {
        const range = {
            min: dateRange.startTS || Number.POSITIVE_INFINITY,
            max: dateRange.stopTS || Number.NEGATIVE_INFINITY
        };
        this._datasets.forEach(dataset => {
            if (range.min > dataset.metadata.min_time)
                range.min = dataset.metadata.min_time;
            if (range.max < dataset.metadata.max_time)
                range.max = dataset.metadata.max_time;
        });
        return [range.min, range.max];
    }
    findDatasetsByServiceIdAndStyle(serviceId, style = null) {
        const filtered = this.datasets.filter(x => x.serviceId == serviceId);
        if (style != null)
            return filtered.filter(x => x.style == style);
        else
            return filtered;
    }
    static getValueRange(datasets) {
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        datasets.forEach(dataset => {
            if (range.min > dataset.metadata.min_value)
                range.min = dataset.metadata.min_value;
            if (range.max < dataset.metadata.max_value)
                range.max = dataset.metadata.max_value;
        });
        return [range.min, range.max];
    }
}
exports.default = DatasetEntityArrayManagement;
